import { render } from "./TeamPage.vue?vue&type=template&id=533f4c0e&scoped=true"
import script from "./TeamPage.vue?vue&type=script&lang=js"
export * from "./TeamPage.vue?vue&type=script&lang=js"

import "./TeamPage.vue?vue&type=style&index=0&id=533f4c0e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533f4c0e"]])

export default __exports__